import ShippingInfo from "@/app/shared/orders/tracking/shipping-info";
import TrackingHistory from "@/app/shared/orders/tracking/tracking-history";
import TrackingOverview from "@/app/shared/orders/tracking/tracking-overview";
import PageHeader from "@/app/shared/page-header";
import routes from "@/routers/routes";
import { fetchOrderById, fetchTracks } from "@/server/api-services";
import { Order, OrderStatus, Track } from "@/types";
import { useEffect, useMemo, useState } from "react";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";

export default function TrackingPage() {
    const { id } = useParams();
    const [order, setOrder] = useState({} as Order);
    const [trackingHistory, setTrackingHistory] = useState([] as Track[]);

    const pageHeader = useMemo(() => {
        return {
            title: "Tracking",
            breadcrumb: [
                {
                    name: "Home",
                },
                {
                    name: "Orders",
                    href: routes.orders.list,
                },
                {
                    name: "Tracking",
                },
                {
                    name: id ?? "",
                },
            ],
        };
    }, [id]);

    useEffect(() => {
        if (!id) return;
        getOrder();
        getTracks();
    }, [id]);

    const getOrder = async () => {
        if (!id) return;

        const response = await fetchOrderById(id as string);

        if (response.statusCode !== 200) {
            return;
        }

        var data = response.data as Order;

        data = {
            ...data,
            status: OrderStatus[data.status as keyof typeof OrderStatus],
        };

        setOrder(data);
    };

    async function getTracks() {
        const response = await fetchTracks(id as string);
        if (response.statusCode !== 200) {
            toast.error("Failed to fetch order");
            return;
        }

        var data = response.data as Track[];

        setTrackingHistory(data);
    }

    return (
        <>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
            />
            <TrackingOverview
                order={order}
                tracks={trackingHistory}
                className="mb-10"
            />
            <ShippingInfo order={order} />
            <TrackingHistory Tracks={trackingHistory} />
        </>
    );
}
